/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reference: NonNullable<unknown> }} Ticketpagesheetorder3Inputs */

const en_ticketpagesheetorder3 = /** @type {(inputs: Ticketpagesheetorder3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Order ${i?.reference}`)
};

const de_ticketpagesheetorder3 = /** @type {(inputs: Ticketpagesheetorder3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bestellung ${i?.reference}`)
};

/**
* | output |
* | --- |
* | "Order {reference}" |
*
* @param {Ticketpagesheetorder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagesheetorder3 = /** @type {((inputs: Ticketpagesheetorder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagesheetorder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagesheetorder3(inputs)
	return de_ticketpagesheetorder3(inputs)
});
export { ticketpagesheetorder3 as "ticketPageSheetOrder" }